import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

export interface RestoreDraftDialogData {
  savedAt: Date;
  hasFiles: boolean;
}

@Component({
    selector: 'app-restore-draft-dialog',
    imports: [
        CommonModule,
        MatIconModule,
        MatDialogModule,
        TranslateModule
    ],
    templateUrl: './restore-draft-dialog.component.html',
    styleUrls: ['./restore-draft-dialog.component.scss']
})
export class RestoreDraftDialogComponent {
  savedAt: Date;
  hasFiles: boolean;

  constructor(
    private dialogRef: MatDialogRef<RestoreDraftDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: RestoreDraftDialogData
  ) {
    this.savedAt = data.savedAt;
    this.hasFiles = data.hasFiles;
  }

  onRestore(): void {
    this.dialogRef.close(true);
  }

  onDiscard(): void {
    this.dialogRef.close(false);
  }
}
